import React, { useContext, useEffect, useState } from 'react';
import { DashboardContext } from '../../../contexts/LayoutDashboardContext';
import { PropertiesContext } from 'contexts/PropertiesContext';
import useDimension from 'utils/use-dimension';
import { Button, DateRangePicker, Drawer, Icon, IconButton, SelectPicker, Tooltip, Whisper } from 'rsuite';
import { addDays, endOfQuarter, startOfQuarter, startOfYear, subDays, subQuarters, differenceInWeeks } from 'date-fns';
import styled from '@emotion/styled';
import { uniqBy } from 'lodash';
import Styles from './styles.js';
import insightsData from 'insights';
import { useUser } from 'contexts/UserContext';
import {
  dropDownOptions,
  analyticsMaker,
  dates,
  SectionData,
  useValues,
  weeklyByPeriod,
  lastNumberWeeks,
  valuesRanges,
} from '../../../containers/DashboardMarketing/index.js';
import managementData from '../../../containers/DashboardMarketing/managementData.js';
import marketingData from '../../../containers/DashboardMarketing/marketingData.js';
import tenantData from '../../../containers/DashboardMarketing/tenantData.js';
import leasingData from '../../../containers/DashboardMarketing/leasingData.js';

export default function DashboardFilters() {
  const { dashboardState, dashboardDispatch } = useContext(DashboardContext);
  const propertiesContext = useContext(PropertiesContext);
  const { width } = useDimension();
  const [show, setShow] = useState(false);
  const [insightsUser, setInsightsUser] = useState(false);
  const user = useUser();
  const useTestData = true;

  // const fetchData = {
  //   portfolios: [],
  //   buildings: ['Bridge Condos', 'Parkway Apartments'],
  //   path: [
  //     'Net Rental Income',
  //     'Capital Expenditure',
  //     'Net Operating Income',
  //     'Occupancy',
  //     'Total expenses',
  //     'Total Sq.ft',
  //     'Total # of units',
  //     'Net Eff Rent/Sft',
  //   ],
  // };

  useEffect(() => {
    //if user is in the approved list
    if (insightsData.validUsers.includes(user.user.email)) {
      setInsightsUser(true);
    }
  }, []);

  //tailwind class "flex flex-row flex-wrap space-x-1 -mt-2"
  const FlexDiv = styled('div')`
    display: flex;
    flex-direction: row;
    --tw-space-x-reverse: 0;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse));
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse)));
    margin-top: -0.5rem;
    flex-wrap: wrap;
  `;

  //tailwind class "grid grid-row-4 gap-2"
  const GridDiv = styled('div')`
    display: grid;
    grid-auto-columns: 1fr;
    grid-auto-rows: 1fr;
    grid-template-rows: 1fr 1fr 1fr;
    gap: 0.5em 0.5em;
  `;

  const filterType = [
    ...(dashboardState.DashboardTab.module === 'analytics' ? [{ label: 'Overview', value: 'overview' }] : []),
    ...(insightsUser ? [{ label: 'Marketing', value: 'marketing' }] : []),
    { label: 'Leasing', value: 'leasing' },
    ...(insightsUser ? [{ label: 'Management', value: 'management' }] : []),
    ...(insightsUser ? [{ label: 'Tenants', value: 'tenants' }] : []),
  ];

  const close = () => {
    setShow(false);
  };
  const toggleDrawer = () => {
    setShow(!show);
  };

  const getDataObject = () => {
    if (dashboardState.DashboardTab?.filter === 'leasing') {
      return leasingData;
    }
    if (dashboardState.DashboardTab?.filter === 'tenants') {
      return tenantData;
    }
    if (dashboardState.DashboardTab?.filter === 'marketing') {
      return marketingData;
    }
    if (dashboardState.DashboardTab?.filter === 'management') {
      return managementData;
    }
    if (dashboardState.DashboardTab?.filter === 'overview') {
      return leasingData;
    }
  };

  console.log('dropDownOptions(getDataObject())', useValues);

  const yearInfo = {};

  const getYearData = () => {
    const yearsArray = [];
    useValues.Years.forEach((y, i) => {
      if (!yearInfo[y]) {
        yearInfo[y] = { months: [], quarters: [] };
      }
      let month = useValues.Months[i];
      let quarter = useValues.DateQuarters[i];
      if (yearInfo[y]['months'].indexOf(month) == -1) {
        yearInfo[y]['months'].push(month);
      }
      if (yearInfo[y]['quarters'].indexOf(quarter) == -1) {
        yearInfo[y]['quarters'].push(quarter);
      }
      yearsArray.indexOf(y) > -1 ? null : yearsArray.push(y);
    });

    return yearsArray.map(y => {
      return { label: '20' + y, value: y };
    });
  };

  console.log('yearInfo', yearInfo);
  const graphTypes = ['Monthly', 'Quaterly'];
  const graphTypesData = graphTypes.map(t => {
    return { label: t, value: t };
  });
  console.log({ dashboardTabTwo: dashboardState.DashboardTab });

  const getTestPortfolioData = () => {
    return dropDownOptions(getDataObject()).portfolios.map(d => {
      return { label: d, value: d };
    });
  };

  const portfolioData = useTestData
    ? getTestPortfolioData()
    : [
        { label: 'Boston', value: 'boston' },
        { label: 'New York', value: 'newYork' },
        { label: 'Toronto', value: 'toronto' },
        { label: 'Philadelphia', value: 'philadelphia' },
      ];

  const getTestBuildingData = () => {
    return dropDownOptions(getDataObject())[
      dashboardState.DashboardTab?.portfolio ? dashboardState.DashboardTab?.portfolio : 'buildings'
    ]?.map(d => {
      return { label: d, value: d };
    });
  };

  const buildingData = useTestData
    ? getTestBuildingData()
    : insightsUser
    ? [
        {
          label: 'Troy Boston',
          value: 'Troy Boston',
        },
        {
          label: 'Parkway Apartments',
          value: 'Parkway Apartments',
        },
        {
          label: 'Bridge Condos',
          value: 'Bridge Condos',
        },
        {
          label: 'Liberty Towers',
          value: 'Liberty Towers',
        },
      ]
    : propertiesContext?.state?.data &&
      uniqBy(propertiesContext?.state?.data, 'buildingName').map(p => {
        return {
          label: p.buildingName || p.address?.shortAddress,
          value: p.buildingName || p.address?.shortAddress,
        };
      });

  return (
    <>
      <div className="dashboard-filters">
        <FlexDiv>
          {width > 992 ? (
            <>
              {insightsUser && (
                <div style={{ paddingLeft: '0.5em' }}>
                  <SelectPicker
                    disabled={dashboardState.DashboardTab?.filter === 'overview'}
                    data={portfolioData}
                    onChange={val =>
                      dashboardDispatch({
                        type: 'setPortfolio',
                        payload: val,
                      })
                    }
                    appearance="default"
                    placeholder="Select Portfolio"
                    value={dashboardState.DashboardTab?.portfolio}
                    searchable={false}
                  />
                </div>
              )}
              {dashboardState.DashboardTab?.module === 'analytics' && (
                <div style={{ paddingLeft: '0.5em' }}>
                  <SelectPicker
                    disabled={dashboardState.DashboardTab?.filter === 'overview'}
                    data={buildingData}
                    onChange={val =>
                      dashboardDispatch({
                        type: 'setBuilding',
                        payload: val,
                      })
                    }
                    appearance="default"
                    placeholder="Select Building"
                    value={dashboardState.DashboardTab?.buildingName}
                  />
                </div>
              )}
              {/* {useTestData && (
                <div style={{ paddingLeft: '0.5em' }}>
                  <SelectPicker
                    data={getYearData()}
                    onChange={val =>
                      dashboardDispatch({
                        type: 'setYear',
                        payload: val,
                      })
                    }
                    appearance="default"
                    placeholder="Select Year"
                    value={dashboardState.DashboardTab?.year}
                    searchable={false}
                  />
                </div>
              )} */}
              {/* {useTestData && (
                <div style={{ paddingLeft: '0.5em' }}>
                  <SelectPicker
                    data={graphTypesData}
                    onChange={val =>
                      dashboardDispatch({
                        type: 'setGraphRange',
                        payload: val,
                      })
                    }
                    appearance="default"
                    placeholder="Select Graph Type"
                    value={dashboardState.DashboardTab?.graphRange}
                    searchable={false}
                  />
                </div>
              )} */}
              {
                <div style={{ paddingLeft: '0.5em' }}>
                  <DateRangePicker
                    placeholder="Select Date Range"
                    disabled={dashboardState.DashboardTab?.filter === 'overview'}
                    showWeekNumbers={true}
                    ranges={[
                      {
                        label: 'Last Quarter',
                        value: [subQuarters(startOfQuarter(new Date()), 1), subQuarters(endOfQuarter(new Date()), 1)],
                      },
                      {
                        label: 'This Quarter',
                        value: [startOfQuarter(new Date()), endOfQuarter(new Date())],
                      },
                      {
                        label: 'Year To Date',
                        value: [
                          new Date(dates[valuesRanges['22']['22'].start]),
                          new Date(dates[valuesRanges['22']['22'].end]),
                        ],
                      },
                      {
                        label: 'Last Year',
                        value: [
                          new Date(dates[valuesRanges['21']['21'].start]),
                          new Date(dates[valuesRanges['21']['21'].end]),
                        ],
                      },
                    ]}
                    onChange={val => {
                      dashboardDispatch({
                        type: 'setDateRange',
                        payload: val,
                      });
                    }}
                    value={dashboardState.DashboardTab?.dateRange}
                    placement="bottomRight"
                  />
                </div>
              }
              <div style={{ paddingLeft: '0.5em' }}>
                <SelectPicker
                  data={filterType}
                  onChange={val => {
                    dashboardDispatch({
                      type: 'setFilter',
                      payload: val,
                    });
                    dashboardDispatch({
                      type: 'setBuilding',
                      payload: '',
                    });
                  }}
                  appearance="default"
                  placeholder="Overview"
                  value={dashboardState.DashboardTab?.filter}
                  searchable={false}
                  cleanable={false}
                />
              </div>
              {/* Analytics/Insights toggle for testing */}
              {/* {insightsUser && (
                <div style={{ paddingLeft: '0.5em' }}>
                  <SelectPicker
                    data={[
                      { label: 'Analytics', value: 'analytics' },
                      { label: 'Insights', value: 'insights' },
                    ]}
                    onChange={val => {
                      dashboardDispatch({
                        type: 'setModule',
                        payload: val,
                      });
                    }}
                    appearance="default"
                    placeholder="Overview"
                    value={dashboardState.DashboardTab?.module}
                    searchable={false}
                    cleanable={false}
                  />
                </div>
              )} */}
            </>
          ) : (
            <div style={{ paddingLeft: '0.5em' }} className="filter-button">
              <IconButton
                icon={<Icon icon="setting" />}
                circle
                onClick={() => {
                  toggleDrawer();
                }}
              />
            </div>
          )}
        </FlexDiv>

        <Drawer placement={'top'} show={show} onHide={() => close()}>
          <Drawer.Header>
            <Drawer.Title>
              Dashboard:{' '}
              {
                filterType.find(t => {
                  return t.value === dashboardState.DashboardTab?.filter;
                })?.label
              }
            </Drawer.Title>
          </Drawer.Header>
          <Drawer.Body>
            <GridDiv>
              {insightsUser && (
                <div style={{ paddingLeft: '0.5em' }}>
                  <SelectPicker
                    block
                    cleanable={false}
                    disabled={dashboardState.DashboardTab?.filter === 'overview'}
                    data={portfolioData}
                    onChange={val =>
                      dashboardDispatch({
                        type: 'setPortfolio',
                        payload: val,
                      })
                    }
                    appearance="default"
                    placeholder="Select Portfolio"
                    value={dashboardState.DashboardTab?.portfolio}
                    searchable={false}
                  />
                </div>
              )}
              <div>
                <SelectPicker
                  block
                  cleanable={false}
                  disabled={dashboardState.DashboardTab?.filter === 'overview'}
                  data={
                    insightsUser
                      ? [
                          {
                            label: 'Troy Boston',
                            value: 'Troy Boston',
                          },
                          {
                            label: 'Parkway Apartments',
                            value: 'Parkway Apartments',
                          },
                          {
                            label: 'Bridge Condos',
                            value: 'Bridge Condos',
                          },
                          {
                            label: 'Liberty Towers',
                            value: 'Liberty Towers',
                          },
                        ]
                      : propertiesContext?.state?.data &&
                        propertiesContext?.state?.data.map(p => {
                          return {
                            label: p.buildingName || p.address?.shortAddress,
                            value: p.buildingName || p.address?.shortAddress,
                          };
                        })
                  }
                  onChange={val =>
                    dashboardDispatch({
                      type: 'setBuilding',
                      payload: val,
                    })
                  }
                  appearance="default"
                  placeholder="Select Building"
                  value={dashboardState.DashboardTab?.buildingName}
                />
              </div>
              <div>
                <DateRangePicker
                  block
                  placeholder="Select Date Range"
                  disabled={dashboardState.DashboardTab?.filter === 'overview'}
                  ranges={[
                    {
                      label: 'Yesterday',
                      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
                    },
                    {
                      label: 'Today',
                      value: [new Date(), new Date()],
                    },
                    {
                      label: 'Last 7 days',
                      value: [subDays(new Date(), 6), new Date()],
                    },
                    {
                      label: 'Next 7 days',
                      value: [addDays(new Date(), 7), new Date()],
                    },
                  ]}
                  onChange={val =>
                    dashboardDispatch({
                      type: 'setDateRange',
                      payload: val,
                    })
                  }
                  value={dashboardState.DashboardTab?.dateRange}
                />
              </div>
              <div>
                <SelectPicker
                  block
                  cleanable={false}
                  data={filterType}
                  onChange={val => {
                    dashboardDispatch({
                      type: 'setFilter',
                      payload: val,
                    });
                    dashboardDispatch({
                      type: 'setBuilding',
                      payload: '',
                    });
                    close();
                  }}
                  appearance="default"
                  placeholder="Overview"
                  value={dashboardState.DashboardTab?.filter}
                  searchable={false}
                />
              </div>
              {/* Analytics/Insights toggle for testing */}
              {/* {insightsUser && (
                <div>
                  <SelectPicker
                    block
                    cleanable={false}
                    data={[
                      { label: 'Analytics', value: 'analytics' },
                      { label: 'Insights', value: 'insights' },
                    ]}
                    onChange={val => {
                      dashboardDispatch({
                        type: 'setModule',
                        payload: val,
                      });
                      close();
                    }}
                    appearance="default"
                    placeholder=""
                    value={dashboardState.DashboardTab?.module}
                    searchable={false}
                  />
                </div>
              )} */}
              <div style={{ textAlign: 'center' }} className="justify-self-center">
                <Button onClick={() => close()} appearance="subtle">
                  Close
                </Button>
              </div>
            </GridDiv>
          </Drawer.Body>
        </Drawer>
      </div>
      <Styles />
    </>
  );
}
